import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { CopyLinesComponent } from "../copy-lines/copy-lines.component";
import { v4 as uuidv4 } from "uuid";
import buildQuery from "odata-query";
import { Table, TableModule } from "primeng/table";
import { CopyLinesDto } from "../../../../core/models/orders/copyLinesDto";
import { GetSalesOrderWithLinesDto } from "../../../../core/models/orders/getSalesOrderWithLinesDto";
import { PoEmailData } from "../../../../core/models/orders/PoEmailData";
import { PurchaseOrderIdDto } from "../../../../core/models/orders/purchaseOrderIdDto";
import { SalesOrderHeader } from "../../../../core/models/orders/saleOrderHeader";
import { SalesOrderLine } from "../../../../core/models/orders/saleOrderLine";
import { SaleOrderLineAddressDto } from "../../../../core/models/orders/saleOrderLineAddressDto";
import { SaleOrderLinePortalKeyDto } from "../../../../core/models/orders/saleOrderLinePortalKeyDto";
import { SaleOrderResponseDto } from "../../../../core/models/orders/saleOrderResponseDto";
import { UpdateSalesOrderLineDto } from "../../../../core/models/orders/updateSalesOrderLineDto";
import { UpdateTrackableOnSalesOrderLinesRequestDto } from "../../../../core/models/orders/updateTrackableOnSalesOrderLinesRequestDto";
import { VendorInvoiceJournalDetailValue } from "../../../../core/models/orders/vendorInvoiceJournalDetailValue";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderLineItemService } from "../../../../core/services/order-line-item.service";
import { EnumOrderEmailState } from "../../../../shared/enums/orderEmailState.enum";
import { CommonModule } from "@angular/common";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { UnmatchUrlDialogComponent } from "../unmatch-url-dialog/unmatch-url-dialog.component";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import { DialogModule } from "primeng/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PoEmailComponent } from "../po-email/po-email.component";
import { OrderLineItemComponent } from "../order-line-item/order-line-item.component";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { Address } from "../../../../core/models/shared/address";
import { VendorSourcing } from "../../../../core/models/orders/vendorSourcing";
import { SaleOrderLinesDto } from "../../../../core/models/orders/saleOrderLinesDto";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { ShipTo } from "../../../../core/models/orders/shipTo";
import { LinesDetail } from "../../../../core/models/orders/lineDetails";
import { ReleasedProductVariants } from "../../../../core/models/shared/releasedProductVariants";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { InventoryWarehouseDto } from "../../../../core/models/inventory/inventory-lookup.models";
import { JniStoreDefaultDto } from "../../../../core/models/inventory/inventory-lookup.models";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";
import { MISC_RELEASED_PRODUCT } from "../../../../shared/constants/misc-constant";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { forkJoin, of, Subject } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@UntilDestroy()
@Component({
  selector: "jni-order-summary-line-items",
  templateUrl: "./order-summary-line-items.component.html",
  styleUrls: ["./order-summary-line-items.component.scss"],
  providers: [],
  imports: [
    CopyLinesComponent,
    TableModule,
    CommonModule,
    ModalStackerComponent,
    UnmatchUrlDialogComponent,
    ConfirmDialogComponent,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    PoEmailComponent,
    OrderLineItemComponent,
    CheckboxModule,
    InputTextModule,
    ToggleSwitchModule,
    RadioButtonModule,
    SpinnerComponent,
    ButtonModule,
    TooltipModule,
  ],
})
export class OrderSummaryLineItemsComponent implements OnChanges {
  @Input() salesOrderLine: SaleOrderLineAddressDto[] = [];
  @Input() OrderLineId = "";
  @Input() currencyConversion!: ExchangeRatesDto;
  @Input() foreignCurrency!: string;
  @Input() salesOrderLines: SaleOrderLineAddressDto[] = [];
  @Input() releasedProductsList: ReleasedProduct[] = [];
  @Input() purchaseOrderIdList: PurchaseOrderIdDto[] = [];
  @Input() orderType = "";
  @Input() customerFinancialDimension = "";
  @Input() releasedProductsVariantsList: ReleasedProductVariants[] = [];
  @Input() warehouseList: InventoryWarehouseDto[] = [];
  @Input() fromCDI = false;
  @Output() changeDetect = new EventEmitter<boolean>();
  @Output() gridRefresh = new EventEmitter<boolean>();
  @Output() lineGridRefresh = new EventEmitter<boolean>();
  @Output() loadReleasedProductsEvent = new EventEmitter();
  modalDataChanged = false;
  @Output() getPoListEvent = new EventEmitter();
  @Input() smallLoader = false;
  @Input() salesOrderStatusD365 = "";
  @Input() approvalStatusD365 = "";
  @Input() isSaleOrderLineConfirmStatus = false;
  @Input() avaiableCredit = 0;
  @Input() subtotalForCreditLimitCheck = 0;
  @Input() getAvailableCreditBtnStatus = false;
  @Input() saleOrderModalStatus = false;
  @Input() userBlockedFromEdit = false;
  @Input() isCdi = false;
  @Input() cdiRecId = 0;
  @Input() linesVendorNumber = "";
  @Input() proposalIdD365EditFieldValidation = false;
  @Input() isLineEditDisabled = false;
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() calculateSubtotalsAndNet = new EventEmitter();
  @Input() isFromOrderSummary = false;
  @Output() isAnyUnCommitLines = new EventEmitter<boolean>();
  @Input() isPartiallyInvoicedOrderLines = false;
  @Input() serviceFeeFromD365 = 0;
  @Output() selectedLineItemsEvent = new EventEmitter();
  selectedSaleOrderLine: SaleOrderLineAddressDto[] = [];
  getSalesOrderWithLinesDto: GetSalesOrderWithLinesDto[] = [];
  vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  salesOrderHeader: SalesOrderHeader[] = [];
  selectedSalesOrderHeader: SalesOrderHeader[] = [];
  selectedSalesOrderLine: SalesOrderLine[] = [];
  descriptionCharacterCond = false;
  miscReleasedProduct: ReleasedProduct = MISC_RELEASED_PRODUCT;
  soStopped: ReleasedProduct[] = [];

  showSmallLoader = false;
  //selectedLines: any;
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";
  c = "";
  selectionMode = "";

  sellReteAfterConversion = 0;
  sellConvertToUsd = "";
  sellTotalPrice = "";
  sellTotalPriceConverted = "";
  showLoader = true;
  grossProfit = 0;
  commission = 0;
  percentageSign = "%";
  unmatchQuantityStatus = false;
  disabledPoNumber = false;
  orderLineDisplayModal = false;
  orderLineNumber = 0;
  deleteButtonStatus = false;
  viewPoNumber = "";
  shipTo = {} as ShipTo;
  vendor = {} as VendorSourcing;
  detail = {} as LinesDetail;
  showWarningCategoryChangedDialog = false;
  //product: any;

  filteredReleasedProductsList: ReleasedProduct[] = [];

  filteredColors: string[] = [];
  filteredSizes: string[] = [];
  filteredStyles: string[] = [];
  filteredConfigs: string[] = [];
  currentEditingItemNumber = "";
  // switchMap cancels any in-flight cost lookup when a newer variant change arrives.
  private netPriceTrigger$ = new Subject<{
    odataFilter: string;
    salesOrderLine: SalesOrderLine;
  }>();

  popUpMessage = "Are you sure you want to delete the selected lines?";
  dialogStatus = false;
  addNewLineCase = false;
  showWarningTrackleAllDialog = false;
  isTrackableAllChecked = false;
  salesOrderLineTrackable: SaleOrderLineAddressDto[] = [];
  displayModal = false;
  closable = false;

  items = [
    {
      productNumber: "RHNAM-236-BLK-2X",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "2X",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-3X",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "3X",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-4X",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "4X",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-LG",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "LG",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-MD",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "MD",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-SM",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "SM",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-XL",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "XL",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-236-BLK-XS",
      productName: "Eddie Bauer Ladies Shaded Crosshatch",
      size: "XS",
      color: "BLK",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-2X",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "2X",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-3X",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "3X",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-4X",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "4X",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-5X",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "5X",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-LG",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "LG",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-MD",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "MD",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-SM",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "SM",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-XL",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "XL",
      color: "GRY",
      customer: "80011117",
    },
    {
      productNumber: "RHNAM-231-GRY-XS",
      productName: "Red Hat Fedora Cap Heather Grey T-Shirt",
      size: "XS",
      color: "GRY",
      customer: "80011117",
    },
  ];

  @ViewChild("dt") table!: Table;
  @ViewChild("copyline", { static: false })
  copyline!: CopyLinesComponent;
  poEmailData: PoEmailData = {} as PoEmailData;
  poEmailDisplayModal = false;
  poAssigment = [
    {
      id: 0,
      name: "Default",
      status: false,
    },
    {
      id: 1,
      name: "New",
      status: false,
    },
    {
      id: 2,
      name: "Existing",
      status: false,
    },
  ];

  disablePopover = false;
  @Input() hideButtonsOnPageLoad = false;
  isAddLineButtonVisible = false;

  prevQuantity = 0;
  // @ViewChild('vendorSkuInput') vendorSkuInput: any;
  @Input() workflowAssigned = false;
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() saleOrderData = {} as SaleOrderResponseDto;
  @Input() headerSiteId = "";
  @Input() headerWarehouseId = "";
  @Input() headerLocationId = "";
  @Input() headerStore = "";
  @Input() headerOwner = "";
  storeDefaultsList: JniStoreDefaultDto[] = [];

  defaultSortSelection = "Dflt";

  toolTipOptions = {
    autoHide: false,
    escape: false,
    tooltipEvent: "hover" as const,
    tooltipPosition: "top" as const,
    tooltipStyleClass: "tooltipwidth",
  };

  constructor(
    private _router: Router,
    private _orderLineItem: OrderLineItemService,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _orderSummary: OrderSummaryService,
    private _orderSummaryService: OrderSummaryService,
    private _addNewClientService: AddNewClientService,
    private _samplepoListingService: SamplepoListingService
  ) {
    this._samplepoListingService
      .getAllStoreDefaults()
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        this.storeDefaultsList = res?.data ?? [];
      });

    this.netPriceTrigger$
      .pipe(
        switchMap(({ odataFilter, salesOrderLine }) =>
          this._samplepoListingService
            .getItemAvailPhysicalCost(odataFilter)
            .pipe(
              catchError(() => of(null)),
              map(res => ({ res, salesOrderLine }))
            )
        ),
        untilDestroyed(this)
      )
      .subscribe(({ res, salesOrderLine }) => {
        const costPrice = res?.data?.[0]?.CostPrice ?? 0;
        this.onNetConversion(costPrice, salesOrderLine);
      });
  }

  // true while the global page loader or either small-loader flag is active, used to gate grid actions against double-clicks before a backend response/error arrives
  isGridBusy(): boolean {
    return (
      this.showSmallLoader || this.smallLoader || this._loaderService.status$()
    );
  }

  redirectToLineItem() {
    this.viewPoNumber = "";
    this.addNewLineCase = true;
    if (this.OrderLineId) {
      let state = {} as NavigationExtras;
      if (this.isCdi) {
        state = {
          state: {
            isCdi: this.isCdi,
            cdiRecId: this.cdiRecId,
            linesVendorNumber: this.linesVendorNumber,
            isCdiLineAdd: true,
            viewPoNumber: this.viewPoNumber,
            addNewLineCase: this.addNewLineCase,
          },
        } as NavigationExtras;
      }
      if (this.saleOrderModalStatus) {
        this.orderLineNumber = 0;
        this.orderLineDisplayModal = true;
      } else {
        this.orderLineDisplayModal = false;

        if (!state?.state) {
          state = {
            state: {
              addNewLineCase: this.addNewLineCase,
            },
          } as NavigationExtras;
        }
        this._router.navigate(
          ["/orders/order-line-item/" + this.OrderLineId],
          state
        );
      }
    }
  }

  itemSelected(event: SelectChangeEvent, salesOrderLine: SalesOrderLine) {
    if (salesOrderLine.lineRecIdD365) {
      this.showWarningCategoryChangedDialog = true;
    }

    const target = event.value;
    const itemNumber = target;
    if (this.orderType == "inventory-sales") {
      this.filteredColors = [
        ...new Set(
          this.releasedProductsVariantsList
            .filter(x => x.itemIdD365 == itemNumber && x.colorD365)
            .sort((a, b) => a.colorDisplayOrderD365 - b.colorDisplayOrderD365)
            .map(x => x.colorD365)
        ),
      ];
      this.filteredSizes = [
        ...new Set(
          this.releasedProductsVariantsList
            .filter(x => x.itemIdD365 == itemNumber && x.sizeD365)
            .sort(
              (a, b) =>
                a.sizeGlobalDisplayOrderD365 - b.sizeGlobalDisplayOrderD365
            )
            .map(x => x.sizeD365)
        ),
      ];
      this.filteredConfigs = [
        ...new Set(
          this.releasedProductsVariantsList
            .filter(x => x.itemIdD365 == itemNumber && x.configD365)
            .sort((a, b) => a.configDisplayOrderD365 - b.configDisplayOrderD365)
            .map(x => x.configD365)
        ),
      ];
      this.filteredStyles = [
        ...new Set(
          this.releasedProductsVariantsList
            .filter(x => x.itemIdD365 == itemNumber && x.styleD365)
            .sort((a, b) => a.styleDisplayOrderD365 - b.styleDisplayOrderD365)
            .map(x => x.styleD365)
        ),
      ];

      salesOrderLine.categoryName =
        this.filteredReleasedProductsList.find(
          x => x.itemNumberD365 == itemNumber
        )?.nameD365 ?? "";

      salesOrderLine.productNameD365 =
        this.filteredReleasedProductsList.find(
          x => x.itemNumberD365 == itemNumber
        )?.nameD365 ?? "";

      const color = this.filteredColors[0];
      const size = this.filteredSizes[0];
      const style = this.filteredStyles[0];
      const config = this.filteredConfigs[0];

      salesOrderLine.color = color;
      salesOrderLine.size = size;
      salesOrderLine.style = style;
      salesOrderLine.config = config;

      this.generateDescription(salesOrderLine);
      this.setSellPrice(salesOrderLine);
    }
  }

  setNetPrice(salesOrderLine: SalesOrderLine) {
    const itemNumber = salesOrderLine?.itemNumberD365;
    if (!itemNumber) {
      this.onNetConversion(0, salesOrderLine);
      return;
    }

    const warehouse = salesOrderLine?.warehouse ?? "";
    const site =
      this.warehouseList.find(w => w.warehouseIdD365 == warehouse)
        ?.siteIdD365 ?? "";

    let location = "";
    if (this.headerStore && warehouse) {
      location = this.resolveDefaultLocation(
        this.headerStore,
        warehouse,
        this.headerOwner
      );
    }

    const filter = {
      ItemId: itemNumber,
      ColorId: salesOrderLine?.color ?? "",
      StyleId: salesOrderLine?.style ?? "",
      SizeId: salesOrderLine?.size ?? "",
      configId: "",
      SiteId: site,
      Warehouse: warehouse,
      LocationId: location,
    };
    const odataFilter = buildQuery({ filter });
    this.netPriceTrigger$.next({ odataFilter, salesOrderLine });
  }

  resolveDefaultLocation(
    store: string,
    warehouse: string,
    owner: string
  ): string {
    if (owner) {
      const ownerMatch = this.storeDefaultsList.find(
        x =>
          x.storeD365 === store &&
          x.warehouseD365 === warehouse &&
          x.ownerD365 === owner
      );
      if (ownerMatch) {
        return ownerMatch.locationD365 ?? "";
      }
    }

    const baseMatch = this.storeDefaultsList.find(
      x =>
        x.storeD365 === store && x.warehouseD365 === warehouse && !x.ownerD365
    );
    return baseMatch?.locationD365 ?? "";
  }

  setSellPrice(salesOrderLine: SalesOrderLine) {
    const itemNumber = salesOrderLine?.itemNumberD365;
    const products = this.releasedProductsList.filter(
      x => x.itemNumberD365 == itemNumber
    );

    const salesPrice = products?.[0]?.salesPriceD365 as
      | number
      | string
      | undefined;

    this.calculateSell(salesPrice?.toString() ?? "0", salesOrderLine);
  }

  generateDescription(salesOrderLine: SalesOrderLine) {
    if (this.orderType == "inventory-sales") {
      salesOrderLine.lineDescriptionD365 = `${
        salesOrderLine.productNameD365 ?? ""
      }${salesOrderLine.color ? "-" : ""}${salesOrderLine.color ?? ""}${
        salesOrderLine.style ? "-" : ""
      }${salesOrderLine.style ?? ""}${salesOrderLine.size ? "-" : ""}${
        salesOrderLine.size ?? ""
      }`;

      this.setNetPrice(salesOrderLine);
    }
  }

  checkLineItems() {
    const soStoppedList = this.filteredReleasedProductsList.map(
      item => item.itemNumberD365
    );
    const filter = this.salesOrderLines.filter(item =>
      soStoppedList.includes(item.salesOrderLine?.itemNumberD365 ?? "")
    );
    if (filter.length === this.salesOrderLines.length) {
      return { isRestricted: false, items: [] };
    } else {
      const diff = this.salesOrderLines.filter(item => !filter.includes(item));
      return { isRestricted: true, items: diff };
    }
  }

  onRedirectToLinePage(lineNumber: number, id: number, poNumber: string) {
    this.viewPoNumber = poNumber;
    this.addNewLineCase = false; //On edit case it should be false
    if (this.OrderLineId) {
      let state = {} as NavigationExtras;
      if (this.isCdi) {
        state = {
          state: {
            isCdi: this.isCdi,
            cdiRecId: this.cdiRecId,
            linesVendorNumber: this.linesVendorNumber,
            viewPoNumber: poNumber,
            addNewLineCase: this.addNewLineCase,
          },
        } as NavigationExtras;
      }
      if (this.saleOrderModalStatus) {
        this.orderLineNumber = id;
        this.modalDataChanged = false;
        this.orderLineDisplayModal = true;
      } else {
        this.orderLineDisplayModal = false;

        //On edit case it should be false
        if (!state?.state) {
          state = {
            state: {
              addNewLineCase: this.addNewLineCase,
            },
          } as NavigationExtras;
        }

        this._router.navigate(
          ["/orders/order-line-item/" + this.OrderLineId + "/" + id],
          state
        );
      }
    }
  }

  closeModal() {
    this.orderLineDisplayModal = false;
    this.modalDataChanged = false;
    this.gridRefresh.emit();
  }

  closeModalNoRefresh() {
    this.orderLineDisplayModal = false;
  }

  closeModalConditionalRefresh() {
    this.orderLineDisplayModal = false;
    if (this.modalDataChanged) {
      this.modalDataChanged = false;
      this.gridRefresh.emit();
    }
  }

  confirmDialogStatusData(status: boolean) {
    this.dialogStatus = false;
    if (status) {
      this.deleteLineItems();
    }
  }

  onDeleteButton() {
    this.dialogStatus = true;
  }

  refreshGrid() {
    this.gridRefresh.emit();
  }

  refreshLineGrid() {
    this.modalDataChanged = true;
    this.lineGridRefresh.emit();
  }

  onRowEditSave(salesOrderLine: SalesOrderLine) {
    this._loaderService.setLoaderState(true);

    if ((salesOrderLine?.sellD365 ?? 0) < 0) {
      this._toastr.error("Sell amount cannot be less then 0", "Sell");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (
      !salesOrderLine.orderedPurchaseQuantityD365 ||
      salesOrderLine.orderedPurchaseQuantityD365 === 0 ||
      salesOrderLine.orderedPurchaseQuantityD365 === 0
    ) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Quantity is required");
      this.gridRefresh.emit();
      return;
    }

    if (!salesOrderLine.itemNumberD365) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Category is required");
      this.gridRefresh.emit();
      return;
    }

    if (!salesOrderLine.vendorPoAssignmentD365) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "PO Assignment is required");
      this.gridRefresh.emit();
      return;
    }

    if (
      salesOrderLine.vendorPoAssignmentD365 === "Existing" &&
      !salesOrderLine.purchaseOrderD365
    ) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Po Number is required");
      this.gridRefresh.emit();
      return;
    }

    if (salesOrderLine?.lineStatusD365?.toLowerCase() === "delivered") {
      const matchedValue =
        (salesOrderLine.deliverRemainderD365 ??
          salesOrderLine.orderedPurchaseQuantityD365) -
        salesOrderLine.orderedPurchaseQuantityD365;

      if (Number(salesOrderLine?.orderedPurchaseQuantityD365) < matchedValue) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "The QTY cannot be less than the matched qty."
        );
        this.gridRefresh.emit();
        return;
      }

      if (
        salesOrderLine?.deliverRemainderD365 === 0 &&
        this.prevQuantity > salesOrderLine?.orderedPurchaseQuantityD365
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "The QTY cannot be less than the matched qty."
        );
        this.gridRefresh.emit();
        return;
      }
    }

    if (!salesOrderLine.id) {
      salesOrderLine.salesOrderIdD365 = this.OrderLineId;
    } else {
      salesOrderLine.salesOrderIdD365 = this.OrderLineId;

      const lineObject = this.patchValueInLineObject(salesOrderLine);

      const saleOrderLine = this.salesOrderLines.find(
        x => x.salesOrderLine?.id === salesOrderLine.id
      );

      if (saleOrderLine?.address && saleOrderLine?.salesOrderLine) {
        this.shipTo = this.getShipToAddress(
          saleOrderLine.address,
          saleOrderLine.salesOrderLine
        );
        this.vendor = this.getVendor(
          saleOrderLine.salesOrderLine,
          salesOrderLine.vendorPoAssignmentD365
        );
      }

      if (saleOrderLine?.salesOrderLine) {
        this.detail = this.getDetail(saleOrderLine.salesOrderLine);
        this.vendor = this.getVendor(
          saleOrderLine.salesOrderLine,
          salesOrderLine.vendorPoAssignmentD365
        );
      }

      const saleOrderLineRequest: UpdateSalesOrderLineDto = {
        id: salesOrderLine.id,
        lines: lineObject,
        salesOrderId: this.OrderLineId,
        shipTo: Object.keys(this.shipTo).length === 0 ? null : this.shipTo,
        vendor: this.vendor,
        Detail: this.detail,
        purchaseOrderId: salesOrderLine.purchaseOrderD365 ?? "",
      };

      this._orderLineItem
        .updateSaleOrderLine(saleOrderLineRequest)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.cancelAllEditRow();
            if (res.status.toLowerCase() == "success") {
              this._toastr.success(
                "Success",
                res.message || "line item update successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error updating line item"
              );
            }
            this.gridRefresh.emit();
          },
          error: res => {
            this.gridRefresh.emit();
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error updating line item"
            );
          },
        });
    }
  }

  getDropdownOptions(salesOrderLine: SaleOrderLineAddressDto) {
    if (salesOrderLine?.salesOrderLine?.itemNumberD365 === "Misc") {
      return [
        this.miscReleasedProduct,
        ...(this.filteredReleasedProductsList || []),
      ];
    }
    return this.filteredReleasedProductsList || [];
  }

  patchValueInLineObject(saleOrderLineObject: SalesOrderLine) {
    const lineObject: SaleOrderLinesDto = {
      itemNumberD365: saleOrderLineObject?.itemNumberD365,
      externalItemNumberD365: saleOrderLineObject?.externalItemNumberD365,
      orderedPurchaseQuantityD365:
        saleOrderLineObject?.orderedPurchaseQuantityD365,
      isnetInForeignCurrencyStatus:
        saleOrderLineObject?.isnetInForeignCurrencyStatus,
      purchasePriceD365: saleOrderLineObject?.purchasePriceD365,
      netTotalD365: saleOrderLineObject?.netTotalD365,
      netTotal: saleOrderLineObject?.netTotalD365,
      netConversion: saleOrderLineObject?.netConversion,
      netConversionTotal: saleOrderLineObject?.netConversionTotalD365,
      sell: saleOrderLineObject?.sellD365,
      sellTotal: parseFloat(saleOrderLineObject?.sellTotalD365 ?? ""),
      sellConversion: parseFloat(saleOrderLineObject?.sellConversion ?? ""),
      sellConversionTotal: parseFloat(
        saleOrderLineObject?.sellConversionTotal ?? ""
      ),
      commission: saleOrderLineObject?.commissionD365,
      grossProfit: saleOrderLineObject?.grossProfitD365,
      lineDescriptionD365: saleOrderLineObject?.lineDescriptionD365,
      factoryNotes: saleOrderLineObject?.factoryNotesD365,
      currencyCodeD365: saleOrderLineObject?.currencyCodeD365,
      rates: saleOrderLineObject?.rates,
      locationD365: saleOrderLineObject?.locationD365,
      attentionInformationD365: saleOrderLineObject?.attentionInformationD365,
      lineRecIdD365: saleOrderLineObject?.lineRecIdD365,
      size: saleOrderLineObject?.size,
      color: saleOrderLineObject?.color,
      style: saleOrderLineObject?.style,
      config: saleOrderLineObject?.config,
      isTrackable: saleOrderLineObject.isTrackable,
      lineAmountD365: null,
      portalKey: null,
      nickName: null,
      warehouse: saleOrderLineObject?.warehouse,
      salesClassificationD365:
        saleOrderLineObject?.salesClassificationIdD365 &&
        saleOrderLineObject?.salesClassificationNameD365
          ? [
              {
                displayValue:
                  saleOrderLineObject.salesClassificationIdD365.toString(),
                displayName: saleOrderLineObject.salesClassificationNameD365,
              },
            ]
          : undefined,
      productNameD365: saleOrderLineObject?.productNameD365 ?? "",
    };
    return lineObject;
  }

  getShipToAddress(address: Address, saleOrderLine: SalesOrderLine) {
    const addressObject: ShipTo = {
      addressSelectionName: saleOrderLine?.addressSelectionNameD365,
      streetD365: address.streetD365,
      attentionInformationD365: saleOrderLine.attentionInformationD365,
      locationD365: saleOrderLine.locationD365 ?? "",
      countryRegionIdD365: address.countryRegionIdD365 ?? "",
      zipCodeD365: address.zipCodeD365 ?? "",
      cityD365: address.cityD365 ?? "",
      stateD365: address.stateD365 ?? "",
      buildingComplimentD365: address.buildingComplimentD365 ?? "",
      postBoxD365: address.postBoxD365 ?? "",
      countyD365: address.countyD365 ?? "",
      streetNumberD365: address.streetNumberD365 ?? "",
      districtNameD365: address.districtNameD365 ?? "",
      locationIdD365: address.locationIdD365 ?? "",
      addressLocationNumber: saleOrderLine?.addressLocationNumberD365 ?? 0,
      addressD365: address.addressD365,
      shipToVendorAccountD365: saleOrderLine.shipToVendorAccountD365 ?? "",
      deliveryAddressD365: null,
      addressSelectionD365: 0,
      deliveryNameD365: null,
      siteD365: null,
      warehouseD365: null,
      melissaAddressKeyD365: "",
      shipToD365Address: null,
      attention: "",
      isShipToAddressValidationIgnored: false,
    };
    return addressObject;
  }

  getVendor(vendor: SalesOrderLine, vendorPoAssignmentD365: string) {
    const vendorObject = {
      vendorDirectDelivery: vendor.vendorDirectDeliveryD365,
      vendorPoAssignment: vendorPoAssignmentD365 ?? "",
      vendorName: vendor.vendorNameD365,
    } as VendorSourcing;
    return vendorObject;
  }

  getDetail(detail: SalesOrderLine) {
    const detailObject: LinesDetail = {
      shippingMethod: detail.shippingMethodD365,
      accountNumberD365: detail.accountNumberD365,
      shipDate: detail.shipDateD365,
      inHandDate: detail.inHandDateD365,
      firm: detail.firmD365 === 0 ? false : true,
    };
    return detailObject;
  }

  calculateSell(sellPrice: string, lineObject: SalesOrderLine) {
    this.showSmallLoader = true;
    const sellRate = sellPrice.toString().replace(/[^a-zA-Z0-9.]/g, "");
    if (sellRate) {
      if (parseFloat(sellPrice) < 0) {
        this._toastr.error("Sell amount cannot be less then 0", "Sell");
        this.showSmallLoader = false;
        return;
      }

      lineObject.sellD365 = Number(sellRate);

      if (this.currencyConversion) {
        if (this.currencyConversion.Rate != 0) {
          this.sellReteAfterConversion =
            parseFloat(sellRate) * this.currencyConversion?.Rate;
          if (this.sellReteAfterConversion.toString() != "") {
            this.sellConvertToUsd = this.sellReteAfterConversion.toString();
            lineObject.sellConversion = this.sellConvertToUsd;
          }
        }
      }
      this.patchValueInTotalSell(
        sellRate,
        this.sellReteAfterConversion.toString(),
        String(lineObject.orderedPurchaseQuantityD365),
        lineObject
      );
      this.calculateGrossProfit(lineObject);
    } else {
      lineObject.sellConversion = "";
      lineObject.sellTotalD365 = "";
      lineObject.sellConversionTotal = "";
      lineObject.grossProfitD365 = 0;
      lineObject.commissionD365 = 0;
    }

    this.calculateSubtotalsAndNet.emit();
    this.showSmallLoader = false;
  }

  setSizeAndColor(itemNumber: string) {
    this.filteredColors = [
      ...new Set(
        this.releasedProductsVariantsList
          .filter(x => x.itemIdD365 == itemNumber)
          .sort((a, b) => a.colorDisplayOrderD365 - b.colorDisplayOrderD365)
          .map(x => x.colorD365)
      ),
    ];
    this.filteredSizes = [
      ...new Set(
        this.releasedProductsVariantsList
          .filter(x => x.itemIdD365 == itemNumber)
          .sort(
            (a, b) =>
              a.sizeGlobalDisplayOrderD365 - b.sizeGlobalDisplayOrderD365
          )
          .map(x => x.sizeD365)
      ),
    ];
    this.filteredStyles = [
      ...new Set(
        this.releasedProductsVariantsList
          .filter(x => x.itemIdD365 == itemNumber)
          .sort((a, b) => a.styleDisplayOrderD365 - b.styleDisplayOrderD365)
          .map(x => x.styleD365)
      ),
    ];
    this.filteredConfigs = [
      ...new Set(
        this.releasedProductsVariantsList
          .filter(x => x.itemIdD365 == itemNumber)
          .sort((a, b) => a.configDisplayOrderD365 - b.configDisplayOrderD365)
          .map(x => x.configD365)
      ),
    ];
  }

  patchValueInTotalSell(
    sell: string,
    convertedSell: string,
    lineQuantity: string,
    lineObject: SalesOrderLine
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const sellPrice = parseFloat(sell) * parseInt(quantity);
      this.sellTotalPrice = sellPrice.toString();
      lineObject.sellTotalD365 = this.sellTotalPrice;

      const sellPriceCon =
        parseFloat(
          convertedSell === "" || convertedSell === null ? "0" : convertedSell
        ) * parseInt(quantity);
      this.sellTotalPriceConverted = sellPriceCon.toString();
      lineObject.sellConversionTotal = this.sellTotalPriceConverted;
    }
  }

  // onAddNewLine() {
  //   const object: any = {
  //     itemNumberD365: '',
  //     externalItemNumberD365: '',
  //     orderedPurchaseQuantityD365: '',
  //     purchasePriceD365: '',
  //     netTotalD365: '',
  //     netConversion: '',
  //     netConversionTotal: '',
  //     sell: '',
  //     sellTotal: '',
  //     sellConversion: '',
  //     sellConversionTotal: '',
  //     commission: '',
  //     grossProfit: '',
  //     status: '',
  //     lineDescriptionD365: '',
  //     factoryNotes: ''
  //   };
  //   this.salesOrderLine.push(object);
  // }

  onNetConversion(event: number, lineObject: SalesOrderLine) {
    const netRate = event.toString().replace(/[^a-zA-Z0-9.]/g, "");
    if (netRate) {
      const currency = lineObject.currencyCodeD365;
      this.isoCurrencyCode = currency ?? "";
      if (this.currencyConversion) {
        if (this.currencyConversion.Rate != 0) {
          this.netReteAfterConversion =
            parseFloat(netRate) * this.currencyConversion?.Rate;
          if (this.netReteAfterConversion.toString() != "") {
            this.netConvertToUsd = this.netReteAfterConversion.toString();
            lineObject.netConversion = Number(this.netConvertToUsd);
          }
        }
      }

      lineObject.purchasePriceD365 = Number(netRate);

      this.patchValueInTotalNet(
        Number(netRate),
        this.netReteAfterConversion,
        String(lineObject.orderedPurchaseQuantityD365),
        lineObject
      );
      this.calculateGrossProfit(lineObject);
    } else {
      lineObject.netConversion = 0;
      lineObject.netTotalD365 = 0;
      lineObject.netConversionTotalD365 = 0;
      lineObject.grossProfitD365 = 0;
      lineObject.commissionD365 = 0;
    }

    this.calculateSubtotalsAndNet.emit();
  }

  patchValueInTotalNet(
    net: number,
    convertedNet: number,
    lineQuantity: string,
    lineObject: SalesOrderLine
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const netprice = net * parseInt(quantity);
      this.netTotalPrice = netprice.toString();
      lineObject.netTotalD365 = parseFloat(this.netTotalPrice);
      const netPriceCon =
        (convertedNet || convertedNet === null ? 0 : convertedNet) *
        parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      lineObject.netConversionTotalD365 = Number(this.netTotalPriceConverted);
    }
  }

  calculateQuantity(event: number, salesOrderLine: SalesOrderLine) {
    const quantity = event;
    if (quantity) {
      let netPrice = salesOrderLine.purchasePriceD365;
      if (netPrice) {
        netPrice = Number(netPrice.toString().replace(/[^a-zA-Z0-9.]/g, ""));
        const convertedNetPrice = salesOrderLine.netConversion;
        this.patchValueInTotalNet(
          netPrice ?? 0,
          convertedNetPrice ?? 0,
          String(salesOrderLine.orderedPurchaseQuantityD365),
          salesOrderLine
        );
      }
      let sellPrice = salesOrderLine.sellD365;
      if (sellPrice) {
        sellPrice = Number(sellPrice.toString().replace(/[^a-zA-Z0-9.]/g, ""));
        const convertedSellPrice = salesOrderLine.sellConversion;
        this.patchValueInTotalSell(
          String(sellPrice),
          String(convertedSellPrice),
          String(salesOrderLine.orderedPurchaseQuantityD365),
          salesOrderLine
        );
      }
      this.calculateGrossProfit(salesOrderLine);
    }

    this.calculateSubtotalsAndNet.emit();
  }

  calculateGrossProfit(salesOrderLine: SalesOrderLine) {
    const netTotal = salesOrderLine.netTotalD365;
    const sellTotal = parseFloat(salesOrderLine.sellTotalD365 ?? "");
    if (netTotal && sellTotal) {
      const grossProfit = ((sellTotal - netTotal) / sellTotal) * 100;
      const grossProfitRound = grossProfit.toFixed(2).toString();
      this.grossProfit = parseFloat(grossProfitRound);
      salesOrderLine.grossProfitD365 = this.grossProfit;
      const commission = (sellTotal - netTotal) * 0.5;
      const commissionRound = commission.toFixed(2).toString();
      this.commission = parseFloat(commissionRound);
      salesOrderLine.commissionD365 = this.commission;
    }
  }

  confirmAllLines() {
    // if (this.avaiableCredit <= this.subtotalForCreditLimitCheck) {
    //   this._toastr.error(
    //     'Error',
    //     'Subtotal should be less than Available Credit'
    //   );
    //   return;
    // }

    const isEmptyDeliveryName = this.checkIfAnyDeliveryNameIsEmpty();
    if (isEmptyDeliveryName) {
      return;
    }

    this.loadProductsAndExecute(() => {
      const checkItems = this.checkLineItems();
      if (checkItems.isRestricted) {
        this._toastr.error(
          "Error",
          `Inactive item(s) ${checkItems.items[0].salesOrderLine?.itemNumberD365}. Select an alternate item and try again.`
        );
        return;
      }
      this.executeConfirmAllLines();
    });
  }

  private executeConfirmAllLines() {
    this._loaderService.setLoaderState(true);
    this._orderLineItem
      .saveAndConfirmAllSaleOrderLines(this.OrderLineId)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);

          if (res.status.toLowerCase() == "success") {
            if (res.data.confirmSaleOrderResponseDto) {
              this._toastr.success(
                "Success",
                res.message || "All Order Lines Confirmed"
              );
            } else if (res.data.createSalesOrderLineResponseDto) {
              this._toastr.success(
                "Success",
                res.message || "All Order Lines Successfully Created"
              );
            } else {
              this._toastr.success(
                "Success",
                res.message || "Sales Order Is Already Confirmed"
              );
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error Confirming Order Line Items"
            );
          }
          // always resync the grid so stale rows aren't left clickable after a partial/failed confirm
          this.changeDetect.emit(true);
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Confirming Order Line Items"
          );
          this.changeDetect.emit(true);
        },
      });
  }

  checkIfAnyDeliveryNameIsEmpty() {
    // Check if any addressSelectionName is empty or undefined
    const emptyAddressItems = this.salesOrderLine.filter(item => {
      const addressSelectionName =
        item?.salesOrderLine?.addressSelectionNameD365;
      return (
        !addressSelectionName ||
        addressSelectionName.trim() === "" ||
        addressSelectionName === undefined ||
        addressSelectionName === null
      );
    });

    // If any empty addresses found, show error and return
    if (emptyAddressItems.length > 0) {
      const lineNumbers = emptyAddressItems
        .map(item => item?.salesOrderLine?.lineNumberD365)
        .filter(lineNum => lineNum)
        .join(", ");

      this._toastr.error(
        "Error",
        `Ship To Delivery selection is missing for line(s): ${lineNumbers}`
      );
      return true; // Exit the function here
    }

    return false;
  }

  syncCopiedSalesOrderLines() {
    // if (this.avaiableCredit <= this.subtotalForCreditLimitCheck) {
    //   this._toastr.error(
    //     'Error',
    //     'Subtotal should be less than Available Credit'
    //   );
    //   return;
    // }

    const isEmptyDelivery = this.checkIfAnyDeliveryNameIsEmpty();
    if (isEmptyDelivery) {
      return;
    }

    this.loadProductsAndExecute(() => {
      const checkItems = this.checkLineItems();
      if (checkItems.isRestricted) {
        this._toastr.error(
          "Error",
          `Inactive item(s) ${checkItems.items[0].salesOrderLine?.itemNumberD365}. Select an alternate item and try again.`
        );
        return;
      }
      this.executeSyncCopiedSalesOrderLines();
    });
  }

  private executeSyncCopiedSalesOrderLines() {
    this._loaderService.setLoaderState(true);
    this._orderLineItem.syncCopiedSalesOrderLines(this.OrderLineId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        this.changeDetect.emit(true);
        if (res.status.toLowerCase() == "success") {
          if (res.data.Status) {
            this._toastr.success(
              "Success",
              res.message || "All Order Lines Confirmed"
            );
          }
        } else {
          this._toastr.error(
            "Error",
            res.message || "Error Confirming Order Line Items"
          );
        }
      },
      error: res => {
        this.changeDetect.emit(true);
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          res.message || "Error Confirming Order Line Items"
        );
      },
    });
  }

  showModalDialog() {
    if (this.selectedSaleOrderLine && this.selectedSaleOrderLine?.length > 0) {
      this.copyLineItems();
    } else {
      this.displayModal = true;
      this.selectionMode = "Multiple";
      this.copyline.getAllSalesOrderHeader();
      this.copyline.getAllQuoteHeader();
    }
  }

  closeModalDialog() {
    this.displayModal = false;
  }

  copyLineItems() {
    this._loaderService.setLoaderState(true);
    const linesArray: SaleOrderLinePortalKeyDto[] = [];
    this.selectedSaleOrderLine.forEach(x => {
      const soLine = x.salesOrderLine;
      if (soLine) {
        const line: SaleOrderLinePortalKeyDto = {
          ...soLine,
          oldPortalKey: x.salesOrderLine?.portalKeyD365 ?? "",
          portalKeyD365: uuidv4(),
          lineCopiedFrom: x.lineFrom,
        };
        linesArray.push(line);
      }
    });

    const copyLineArray: CopyLinesDto = {
      saleOrderLinePortalKeyDtos: linesArray,
      salesOrderId: this.OrderLineId,
    };
    this.selectedSaleOrderLine = [];

    this._orderSummary
      .addLineData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);

          if (res.data) {
            this.changeDetect.emit(true);
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  exportExcel() {
    this.showLoader = true;
    if (this.selectedSaleOrderLine.length > 0) {
      this.exportExcelForFilterData(this.salesOrderLine);
      this.selectedSaleOrderLine = [];
      this.showLoader = false;
    } else {
      this.exportExcelForFilterData(this.salesOrderLine);
      this.showLoader = false;
    }
  }

  exportExcelForFilterData(filterclientlist: SaleOrderLineAddressDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Line Number"]: datum.salesOrderLine?.lineNumberD365,
        ["Trackable"]: datum.salesOrderLine?.isTrackable,
        ["Vendor Sku"]: datum.salesOrderLine?.externalItemNumberD365,
        ["Category"]: datum.salesOrderLine?.itemNumberD365,
        ["Description"]: datum.salesOrderLine?.lineDescriptionD365,
        ["Unmatched"]: datum.salesOrderLine?.orderedPurchaseQuantityD365,
        ["Quantity"]: datum.salesOrderLine?.orderedPurchaseQuantityD365,
        ["Sell"]: datum.salesOrderLine?.sellD365,
        ["Sell Total"]: datum.salesOrderLine?.sellTotalD365,
        ["Net"]: datum.salesOrderLine?.purchasePriceD365,
        ["Net Total"]: datum.salesOrderLine?.netTotalD365,
        ["Net GP%"]: this.getNetGpPercentage(
          datum.salesOrderLine?.netTotalD365 ?? 0,
          Number(datum.salesOrderLine?.sellTotalD365)
        ).toFixed(2),
        ["Status"]: datum.salesOrderLine?.lineStatusD365,
        ["Vendor Name"]: datum.salesOrderLine?.vendorNameD365,
        ["PO Number"]: datum.salesOrderLine?.purchaseOrderD365,
        ["PO Assignment"]: datum.salesOrderLine?.vendorPoAssignmentD365,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "SaleOrderList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  getNetGpPercentage(netTotal: number, sellTotal: number) {
    const serviceFee = this.serviceFeeFromD365 * sellTotal;
    const netGp = sellTotal - netTotal - serviceFee;
    const netGpPercentage = (netGp / sellTotal) * 100;

    if (Number.isFinite(netGpPercentage)) {
      return netGpPercentage;
    } else {
      return 0;
    }
  }

  openUrlDialog(poNumber: string, saleOrderLine: SalesOrderLine) {
    if (
      saleOrderLine?.deliverRemainderD365 ===
        saleOrderLine?.orderedPurchaseQuantityD365 ||
      (saleOrderLine?.purchasePriceD365 === 0 &&
        (saleOrderLine?.lineStatusD365?.toLowerCase() === "invoiced" ||
          saleOrderLine?.lineStatusD365?.toLowerCase() === "delivered"))
    ) {
      return;
    }
    if (poNumber) {
      const filter = {
        PurchId: poNumber,
      };
      const query = buildQuery({ filter });
      this.vendorInvoiceJournalDetail = [];
      this._loaderService.setLoaderState(true);
      this._orderSummary
        .getUnmatchQuantityUrl(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (res.data.length > 0) {
                this.vendorInvoiceJournalDetail = res.data;
                if (this.vendorInvoiceJournalDetail.length === 1) {
                  const url =
                    this.vendorInvoiceJournalDetail[0].DocumentURL || "";
                  window.open(url, "_blank");
                } else {
                  this.unmatchQuantityStatus = true;
                }
              } else {
                this._toastr.error("Error", "Record not found");
              }
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Record not found");
          },
        });
    } else {
      this._toastr.error("Error", "PO Number is required");
    }
  }

  closeUrlDialog() {
    this.unmatchQuantityStatus = false;
  }

  editLine(
    id: number,
    vendorId: string,
    poAssigment: string,
    lineStatus: string
  ) {
    if (
      lineStatus?.toLowerCase() !== "invoiced" &&
      lineStatus?.toLowerCase() !== "delivered" &&
      this.userBlockedFromEdit
    ) {
      this.cancelAllEditRow();
      const row = this.table.value.filter(x => x.salesOrderLine.id === id);
      if (row.length > 0) {
        this.table.initRowEdit(row[0]);
      }

      if (poAssigment.toLowerCase() !== "existing") {
        this.disabledPoNumber = true;
      }
      this.getPoListEvent.emit(vendorId);
    }
  }

  cancelAllEditRow() {
    this.currentEditingItemNumber = "";
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  hideDeleteLineButton() {
    const filteredLines = this.selectedSaleOrderLine.filter(
      item => item?.salesOrderLine?.itemNumberD365 !== "Set Up"
    );
    this.selectedLineItemsEvent.emit(filteredLines);
    if (this.selectedSaleOrderLine.length > 0) {
      for (const item of this.selectedSaleOrderLine) {
        if (
          item.salesOrderLine?.lineStatusD365?.toLowerCase() === "delivered" ||
          item.salesOrderLine?.lineStatusD365?.toLowerCase() === "invoiced"
        ) {
          this.deleteButtonStatus = true;
          return;
        } else {
          this.deleteButtonStatus = false;
        }
      }
    } else {
      this.deleteButtonStatus = false;
    }
  }

  deleteLineItems() {
    if (this.selectedSaleOrderLine?.length) {
      for (const item of this.selectedSaleOrderLine) {
        if (
          item.salesOrderLine?.lineStatusD365
            ?.toLowerCase()
            .includes("delivered")
        ) {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", `Delivered line can't deleted`);
          return;
        }

        if (
          this.workflowAssigned &&
          (item.projectWorkflowLineDetails?.trackingCount ?? 0) > 0
        ) {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            `Lines can't be deleted, contains Tracking Numbers at the assigned Project`
          );
          return;
        }
      }
      this._loaderService.setLoaderState(true);

      const deleteArray: number[] = [];
      this.selectedSaleOrderLine.forEach(x => {
        deleteArray.push(x.salesOrderLine?.id ?? 0);
      });

      this.selectedSaleOrderLine = [];
      this._orderSummary
        .deleteLineItems(deleteArray)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.salesOrderLine = [];
            this.gridRefresh.emit();
            if (res.status.toLowerCase() == "success") {
              this._toastr.success(
                "Success",
                res.message || "Record Deleted Successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Failed To Delete Line Item"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Failed To Delete Line Item"
            );
          },
        });
    }
  }

  externalItemNumberD365 = false;
  itemNumberD365 = false;
  lineDescriptionD365 = false;
  purchasePriceD365 = false;
  orderedPurchaseQuantityD365 = false;
  vendorPoAssignmentD365 = false;
  onEditRow(
    vendorId: string,
    poAssigment: string,
    lineStatus: string,
    id: string,
    salesOrderLine: SalesOrderLine
  ) {
    this.loadReleasedProductsEvent.emit();
    this.getPoListEvent.emit(vendorId);
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.salesOrderLine.id === id);
    this.prevQuantity = row[0].salesOrderLine.orderedPurchaseQuantityD365;
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
    if (poAssigment.toLowerCase() !== "existing") {
      this.disabledPoNumber = true;
    }
    if (lineStatus?.toLowerCase() === "delivered") {
      this.externalItemNumberD365 = true;
      this.itemNumberD365 = true;

      //this.lineDescriptionD365 = true; // needs to be enabled as per the ticket 11279
      this.lineDescriptionD365 = false;

      this.purchasePriceD365 = true;
      this.orderedPurchaseQuantityD365 = true;
      this.vendorPoAssignmentD365 = true;
      // if (
      //   salesOrderLine.deliverRemainderD365 !== null &&
      //   salesOrderLine.orderedPurchaseQuantityD365 !== null &&
      //   salesOrderLine.deliverRemainderD365 <
      //     salesOrderLine.orderedPurchaseQuantityD365
      // ) {
      //   this.lineDescriptionD365 = false;
      //   this.purchasePriceD365 = false;
      // }
    } else {
      this.externalItemNumberD365 = false;
      this.itemNumberD365 = false;
      this.lineDescriptionD365 = false;
      this.purchasePriceD365 = false;
      this.orderedPurchaseQuantityD365 = false;
      this.vendorPoAssignmentD365 = false;
    }

    this.currentEditingItemNumber = salesOrderLine.itemNumberD365 ?? "";
    this.setSizeAndColor(this.currentEditingItemNumber);
  }

  onPoNumberChange(poAssignment: string, id: number) {
    if (poAssignment) {
      if (poAssignment.toLowerCase() === "new") {
        this.disabledPoNumber = true;
        const lineObject = this.salesOrderLine.find(
          x => x.salesOrderLine?.id === id
        );
        if (lineObject) {
          if (lineObject?.salesOrderLine?.purchaseOrderD365) {
            lineObject.salesOrderLine.purchaseOrderD365 = "";
          }
        }
      } else if (poAssignment.toLowerCase() === "default") {
        this.disabledPoNumber = true;
      } else {
        this.disabledPoNumber = false;
      }
    } else {
      this.disabledPoNumber = true;
    }
  }

  checkOrderIsConfirmed() {
    if (
      !this.approvalStatusD365 ||
      this.approvalStatusD365?.toLowerCase() === "none"
    ) {
      return true;
    } else {
      return false;
    }
  }
  getOddEvenNumber(lineNumber: number) {
    if (lineNumber % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  printPdfByPurchaseOrderId(purchaseOrderId: string) {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.printPOForSalesOrder(purchaseOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message || "Failed To Load PDF");
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  openPdfScreen(purchaseOrderId: string, salesOrderIdD365: string) {
    this.poEmailData.saleOrderId = salesOrderIdD365;
    this.poEmailData.poNumber = purchaseOrderId;
    this.poEmailData.windowState = EnumOrderEmailState.PoPrinting;
    this.poEmailDisplayModal = true;

    // const url = `/orders/po-email/${salesOrderIdD365}/${purchaseOrderId}`;
    // window.open(url, '_blank');
  }

  closeModalForPoEmail() {
    this.poEmailDisplayModal = false;
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }

  getLinesFiltersOnChange(value: RadioButtonClickEvent) {
    const target = value.value as string;
    if (target == "Po") {
      this.salesOrderLine = this.salesOrderLine.sort((a, b) =>
        (a.salesOrderLine?.purchaseOrderD365 ?? "") <
        (b.salesOrderLine?.purchaseOrderD365 ?? "")
          ? -1
          : 1
      );
    } else if (target == "VendorPo") {
      this.salesOrderLine = this.salesOrderLine.sort((a, b) =>
        (a.salesOrderLine?.vendorNameD365 ?? "") <
        (b.salesOrderLine?.vendorNameD365 ?? "")
          ? -1
          : 1
      );
    } else if (target == "InHands") {
      this.salesOrderLine = this.salesOrderLine.sort((a, b) =>
        (a.salesOrderLine?.inHandDateD365 ?? "") <
        (b.salesOrderLine?.inHandDateD365 ?? "")
          ? -1
          : 1
      );
    } else if (target == "OrigLn") {
      this.salesOrderLine = this.salesOrderLine.sort((a, b) =>
        (a.salesOrderLine?.lineNumberD365 ?? "") <
        (b.salesOrderLine?.lineNumberD365 ?? "")
          ? -1
          : 1
      );
    } else {
      this.salesOrderLine = this.salesOrderLine.sort((a, b) =>
        (a.salesOrderLine?.sortOrder ?? "") <
        (b.salesOrderLine?.sortOrder ?? "")
          ? -1
          : 1
      );
    }
  }

  updateOrderLineItemSequence() {
    this._loaderService.setLoaderState(true);
    this._orderLineItem
      .updateOrderLineItemSequence(this.salesOrderLine)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this._loaderService.setLoaderState(false);
            this._toastr.success(
              "Success",
              res?.message || "Line items sequence are updated successfully"
            );
            this.refreshGrid();
            this.refreshLineGrid();
          }
        },
        error: () => {
          this._toastr.error("Error", "No record is updated");
          this._loaderService.setLoaderState(false);
        },
      });
  }
  descriptionCharacterCount(obj: string) {
    if (obj && obj?.length > 45) {
      this.descriptionCharacterCond = true;
    }
  }

  isAddLineVisible() {
    if (!this.isLineEditDisabled) {
      if (this.isCdi) {
        this.isAddLineButtonVisible = true;
      } else {
        this.isAddLineButtonVisible = false;
      }
    } else {
      this.isAddLineButtonVisible = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes?.["orderType"] !== undefined &&
      changes?.["orderType"].currentValue !==
        changes?.["orderType"].previousValue &&
      changes["orderType"].currentValue === "inventory-sales"
    ) {
      this.orderType = changes["orderType"].currentValue;
    }
    this.isAddLineVisible();
    this.customerFinancialDimensionChanges(changes);
    this.releasedProductsChanges(changes);
    this.releasedProductsVariantsChanges(changes);
    this.orderTypeChanges(changes);
  }
  releasedProductsVariantsChanges(changes: SimpleChanges) {
    if (
      changes["releasedProductsVariantsList"] &&
      this.currentEditingItemNumber
    ) {
      this.setSizeAndColor(this.currentEditingItemNumber);
    }
  }
  customerFinancialDimensionChanges(changes: SimpleChanges) {
    if (changes["customerFinancialDimension"]) {
      this.filterProducts();
    }
  }

  releasedProductsChanges(changes: SimpleChanges) {
    if (changes["releasedProductsList"]) {
      if (this.releasedProductsList?.length) {
        this.filterProducts();
      }
    }
  }

  orderTypeChanges(changes: SimpleChanges) {
    if (changes["orderType"]) {
      this.filterProducts();
    }
  }

  filterProducts() {
    if (this.orderType == "inventory-sales") {
      this.filteredReleasedProductsList = this.releasedProductsList.filter(
        x =>
          x.productTypeD365 == "Item" &&
          x.financialDimensionD365 &&
          this.customerFinancialDimension &&
          (((x.financialDimensionD365 as string).split("-").pop() ??
            "") as string) ==
            ((this.customerFinancialDimension.split("-").pop() ??
              "") as string) &&
          ((x.financialDimensionD365 as string).split("-").pop() ?? "") !=
            "-" &&
          x.soStopped === "No"
      );
    } else if (this.orderType != "inventory-sales") {
      this.filteredReleasedProductsList = this.releasedProductsList.filter(
        x => x.productTypeD365 == "Service" && x.soStopped === "No"
      );
    }
  }

  private loadProductsAndExecute(callback: () => void) {
    if (this.filteredReleasedProductsList?.length) {
      callback();
      return;
    }
    this._loaderService.setLoaderState(true);

    const customerAccount =
      this.saleOrderData?.salesOrderHeader?.salesOrderHeader?.customerIdD365 ??
      "";
    const needsFinancialDimension =
      this.orderType === "inventory-sales" &&
      !this.customerFinancialDimension &&
      customerAccount;

    const products$ = this._orderSummaryService.getAllCategory();
    const financialDimension$ = needsFinancialDimension
      ? this._addNewClientService.getCustomerFinancialDimension(customerAccount)
      : of(null);

    forkJoin([products$, financialDimension$])
      .pipe(untilDestroyed(this))
      .subscribe({
        next: ([productsRes, financialRes]) => {
          this._loaderService.setLoaderState(false);
          this.releasedProductsList =
            this.orderType == "inventory-sales"
              ? productsRes.data.filter(item => item.soStopped === "No")
              : productsRes.data.filter(
                  x => x.itemNumberD365 != "Misc" && x.soStopped === "No"
                );
          if (financialRes?.data) {
            this.customerFinancialDimension = financialRes.data;
          }
          this.filterProducts();
          callback();
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed to load released products");
        },
      });
  }

  isAnyUnCommitLinesEvent() {
    this.isAnyUnCommitLines.emit(true);
  }

  updateOrderLineTrackable(salesOrderLine: SalesOrderLine) {
    const objArray: UpdateTrackableOnSalesOrderLinesRequestDto[] = [];
    const obj: UpdateTrackableOnSalesOrderLinesRequestDto =
      {} as UpdateTrackableOnSalesOrderLinesRequestDto;
    obj.lineId = salesOrderLine.id;
    obj.isTrackable = salesOrderLine.isTrackable ?? false;
    objArray.push(obj);
    this.saveTheSalesOrderLinesTrackable(objArray);
  }

  saveAllTrackable() {
    const objArray: UpdateTrackableOnSalesOrderLinesRequestDto[] = [];
    this.salesOrderLineTrackable.forEach(x =>
      objArray.push({
        lineId: x.salesOrderLine?.id ?? 0,
        isTrackable: this.isTrackableAllChecked,
      })
    );
    this.saveTheSalesOrderLinesTrackable(objArray, true);
    this.showWarningTrackleAllDialog = false;
  }

  cancelTrackable() {
    this.showWarningTrackleAllDialog = false;
  }

  saveTheSalesOrderLinesTrackable(
    arrayList: UpdateTrackableOnSalesOrderLinesRequestDto[],
    gridRefresh = false
  ) {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService
      .updateTrackableOnSalesOrderLines(arrayList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          //if (res.data) {
          if (res?.status?.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              res.message || "Trackable save successfully"
            );
            if (gridRefresh) {
              this.gridRefresh.emit();
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error while updating trackable field"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Updating Invoice Email"
          );
        },
      });
  }

  selectedUnselectAllTrackable(event: CheckboxChangeEvent) {
    if (event?.checked) {
      this.isTrackableAllChecked = true;
    } else {
      this.isTrackableAllChecked = false;
    }

    this.salesOrderLineTrackable = this.salesOrderLine.filter(
      x =>
        x.salesOrderLine?.itemNumberD365?.toLowerCase() !== "set up" &&
        x.salesOrderLine?.itemNumberD365?.toLowerCase() !== "setup" &&
        x.salesOrderLine?.lineStatusD365?.toLowerCase() !== "invoiced" &&
        x.salesOrderLine?.lineStatusD365?.toLowerCase() !== "delivered"
    );

    if (this.salesOrderLineTrackable?.length > 0) {
      this.showWarningTrackleAllDialog = true;
    }
  }

  updateSalesOrderLineDtoEvent(obj: UpdateSalesOrderLineDto) {
    if (obj) {
      const findIndex = this.saleOrderData.salesOrderLine?.findIndex(
        x => x?.salesOrderLine?.id === obj?.id
      );
      if (findIndex !== undefined && findIndex !== -1) {
        if (
          this.saleOrderData?.salesOrderLine?.[findIndex].salesOrderLine &&
          this.saleOrderData.salesOrderLine[findIndex].salesOrderLine !== null
        ) {
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.externalItemNumberD365 =
            obj?.lines?.externalItemNumberD365 ?? "";
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.itemNumberD365 = obj?.lines?.itemNumberD365 ?? "";
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.orderedPurchaseQuantityD365 =
            obj?.lines?.orderedPurchaseQuantityD365 ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.currencyCodeD365 =
            obj?.lines?.currencyCodeD365 ?? "";
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.isTrackable = obj?.lines?.isTrackable ?? false;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.nickName = obj?.lines?.nickName ?? "";
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.sellD365 = obj?.lines?.sell ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.sellTotalD365 = (
            obj?.lines?.sellTotal ?? 0
          ).toString();
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.netTotalD365 = obj?.lines?.netTotal ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.purchasePriceD365 =
            obj?.lines?.purchasePriceD365 ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.commissionD365 = obj?.lines?.commission ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.grossProfitD365 = obj?.lines?.grossProfit ?? 0;
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.lineDescriptionD365 =
            obj?.lines?.lineDescriptionD365 ?? "";
          this.saleOrderData.salesOrderLine[
            findIndex
          ].salesOrderLine!.factoryNotesD365 = obj?.lines?.factoryNotes ?? "";
        }
      }
    }
  }

  okCategoryChangedDialog() {
    this.showWarningCategoryChangedDialog = false;
    this.showSmallLoader = false;
  }
}
